import { patientActions, userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'
import _ from 'lodash';

const initialState = {
};

export const reducer = createReducer(initialState, {
    [patientActions.loadLimberAssessmentsSuccess]: (state, action) => {
        const { result, entities } = action.payload.limberAssessments;
        const epno = action.payload.epno;

        // Create a new state object with assessmentId as keys
        const newState = {};
        result.forEach(id => {
            const assessment = entities.limberAssessments[id];
            newState[assessment.assessmentId] = {
                ...assessment,
                epno
            };
        });

        return { ...state, ...newState };
    }
})  